import { SplashScreen } from '@viaja/design-system';
import type { ReactNode } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { ApiError } from '../../lib/api';
import { useMe } from '../../lib/queries';
import { LoadError } from '../../ui/feedback';

/** Barra quem não está logado e mostra a splash do DS enquanto a sessão carrega. */
export function RequireAuth({ children }: { children: ReactNode }) {
  const me = useMe();
  const location = useLocation();
  if (me.isPending) return <SplashScreen className="app-splash" />;
  if (me.error && !(me.error instanceof ApiError && me.error.status === 401)) {
    return (
      <div className="app-screen app-screen--bare">
        <LoadError message={me.error.message} onRetry={() => me.refetch()} />
      </div>
    );
  }
  if (!me.data) return <Navigate to="/entrar" replace state={{ from: location.pathname }} />;
  return <>{children}</>;
}

/** Telas de entrada: quem já está logado vai direto para o app. */
export function GuestOnly({ children }: { children: ReactNode }) {
  const me = useMe();
  if (me.isPending) return <SplashScreen className="app-splash" />;
  if (me.data) return <Navigate to="/" replace />;
  return <>{children}</>;
}
